// extracted by mini-css-extract-plugin
export default {"tooltip":"_t98u6e"};